import { inject, Injectable } from '@angular/core';

import {
  AttendanceByMonthRequestDTO,
  AttendanceList,
  AttendancePointerDTO,
  ClassDashboardKPIResponse,
  KPIsClassDashboardMappingRequestDTO,
  StudentAttendaceList,

  AttendanceSchoolStaffAttendanceKPIRequestDTO,
  AttendanceSchoolStaffAttendanceKPIResponseDTO,
  AttendanceSchoolReadAllPaginatedRequestDTO,
  AttendanceSchoolReadAllPaginatedResponseDTO,

  UserAffiliationMappingCreateRequestDTO,
  UserAffiliationMappingDeleteRequestDTO,
  UserAffiliationMappingDTO,
  UserAffiliationMappingList,
  UserAffiliationMappingReadByIdRequestDTO,
  UserAffiliationMappingReadBySchoolIdRequestDTO,
  UserAffiliationMappingReadByUserIdRequestDTO,
  UserAffiliationMappingReadUserBySchoolIdRequestDTO,
  UserAffiliationMappingUpdateRequestDTO,
  UserAffiliationMappingValidateStudentResponse,
  UserAffiliationMappingValidateStudentUniversal,
  UserAffiliationMappingValidateUniversal,
  AttendanceCheckInCheckOutRequestDTO,
  AttendanceCheckInCheckOutResponseDTO

} from './user-affiliation-mapping.interface';


import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';


import {
  SUserAffiliationMapping_Create,
  SUserAffiliationMapping_Create_External,
  SUserAffiliationMapping_Update,
  SUserAffiliationMapping_ReadAll,
  SUserAffiliationMapping_Delete,
  SUserAffiliationMapping_ReadById,
  SUserAffiliationMapping_ReadBySchoolId,
  SUserAffiliationMapping_ReadByUserId,
  SUserAffiliationMapping_ReadUserBySchoolId,
  SUserAffiliationMapping_ValidateCreateBulk,
  SUserAffiliationMapping_CreateBulk,
  SUserAffiliationMapping_CreateStudentBulk,
  SUserAffiliationMapping_ValidateStudentBulk,

  ClassDashboard_KPI,
  ClassDashboard_StudentAttendanceSummary,
  ClassDashboard_AttendanceClassAvgChart,

  Attendance_SchoolStaffAttendanceKPI,
  Attendance_SchoolReadAllPaginated,
  Attendance_CheckInCheckOut

} from 'src/app/GlobalVariable';



@Injectable({
  providedIn: 'root'
})
export class UserAffiliationMappingService {


  constructor() { }


  http = inject(HttpClient);



  UserAffiliationMapping_Create(
    data: UserAffiliationMappingCreateRequestDTO
  ): Observable<UserAffiliationMappingDTO> {
    return this.http.post<UserAffiliationMappingDTO>(SUserAffiliationMapping_Create, data);
  }

  UserAffiliationMapping_Create_External(
    data: UserAffiliationMappingCreateRequestDTO,
    xApiKey: string,
    xApiTimestamp: string,
    xApiNonce: string,
    xApiSignature: string
  ): Observable<UserAffiliationMappingDTO> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Api-Key': xApiKey,
      'X-Api-Timestamp': xApiTimestamp,
      'X-Api-Nonce': xApiNonce,
      'X-Api-Signature': xApiSignature
    });
    return this.http.post<UserAffiliationMappingDTO>(SUserAffiliationMapping_Create_External, data, { headers });
  }

  UserAffiliationMapping_Update(
    data: UserAffiliationMappingUpdateRequestDTO
  ): Observable<UserAffiliationMappingDTO> {

    return this.http.post<UserAffiliationMappingDTO>(
      SUserAffiliationMapping_Update,
      data
    );

  }



  UserAffiliationMapping_ReadAll(): Observable<UserAffiliationMappingList> {

    return this.http.get<UserAffiliationMappingList>(
      SUserAffiliationMapping_ReadAll
    );

  }



  UserAffiliationMapping_Delete(
    data: UserAffiliationMappingDeleteRequestDTO
  ): Observable<void> {

    return this.http.post<void>(
      SUserAffiliationMapping_Delete,
      data
    );

  }




  UserAffiliationMapping_ReadById(
    data: UserAffiliationMappingReadByIdRequestDTO
  ): Observable<UserAffiliationMappingDTO> {

    return this.http.post<UserAffiliationMappingDTO>(
      SUserAffiliationMapping_ReadById,
      data
    );

  }




  UserAffiliationMapping_ReadBySchoolId(
    data: UserAffiliationMappingReadBySchoolIdRequestDTO
  ): Observable<UserAffiliationMappingList> {

    return this.http.post<UserAffiliationMappingList>(
      SUserAffiliationMapping_ReadBySchoolId,
      data
    );

  }




  UserAffiliationMapping_ReadByUserId(
    data: UserAffiliationMappingReadByUserIdRequestDTO
  ): Observable<UserAffiliationMappingList> {

    return this.http.post<UserAffiliationMappingList>(
      SUserAffiliationMapping_ReadByUserId,
      data
    );

  }





  UserAffiliationMapping_ReadUserBySchoolId(
    data: UserAffiliationMappingReadUserBySchoolIdRequestDTO
  ): Observable<UserAffiliationMappingList> {

    return this.http.post<UserAffiliationMappingList>(
      SUserAffiliationMapping_ReadUserBySchoolId,
      data
    );

  }





  //User - parent/teacher 

  UserAffiliationMapping_ValidateCreateBulk(
    data: UserAffiliationMappingValidateUniversal
  ): Observable<UserAffiliationMappingValidateUniversal> {

    return this.http.post<UserAffiliationMappingValidateUniversal>(
      SUserAffiliationMapping_ValidateCreateBulk,
      data
    );

  }




  UserAffiliationMapping_CreateBulk(
    data: UserAffiliationMappingValidateUniversal
  ): Observable<UserAffiliationMappingList> {

    return this.http.post<UserAffiliationMappingList>(
      SUserAffiliationMapping_CreateBulk,
      data
    );

  }




  //User - student

  UserAffiliationMapping_ValidateStudentBulk(
    data: UserAffiliationMappingValidateStudentUniversal
  ): Observable<UserAffiliationMappingValidateStudentResponse> {

    return this.http.post<UserAffiliationMappingValidateStudentResponse>(
      SUserAffiliationMapping_ValidateStudentBulk,
      data
    );

  }




  UserAffiliationMapping_CreateStudentBulk(
    data: UserAffiliationMappingValidateStudentUniversal
  ): Observable<UserAffiliationMappingList> {

    return this.http.post<UserAffiliationMappingList>(
      SUserAffiliationMapping_CreateStudentBulk,
      data
    );

  }




  //dashboard apis 


  UserAffiliationMapping_ClassDashboardKPI(
    data: KPIsClassDashboardMappingRequestDTO
  ): Observable<ClassDashboardKPIResponse> {

    return this.http.post<ClassDashboardKPIResponse>(
      ClassDashboard_KPI,
      data
    );

  }




  UserAffiliationMapping_GetClassAvgAttendance(
    data: AttendanceByMonthRequestDTO
  ): Observable<AttendanceList> {

    return this.http.post<AttendanceList>(
      ClassDashboard_AttendanceClassAvgChart,
      data
    );

  }




  UserAffiliationMapping_GetStudentLowAvgAttendance(
    data: AttendanceByMonthRequestDTO
  ): Observable<StudentAttendaceList> {

    return this.http.post<StudentAttendaceList>(
      ClassDashboard_StudentAttendanceSummary,
      data
    );

  }





  // =====================================================
  // HRMS SCHOOL STAFF ATTENDANCE APIs
  // =====================================================


  Attendance_SchoolStaffAttendanceKPI(
    data: AttendanceSchoolStaffAttendanceKPIRequestDTO
  ): Observable<AttendanceSchoolStaffAttendanceKPIResponseDTO> {


    return this.http.post<AttendanceSchoolStaffAttendanceKPIResponseDTO>(
      Attendance_SchoolStaffAttendanceKPI,
      data
    );


  }

  Attendance_SchoolReadAllPaginated(
    data: AttendanceSchoolReadAllPaginatedRequestDTO
  ): Observable<AttendanceSchoolReadAllPaginatedResponseDTO> {


    return this.http.post<AttendanceSchoolReadAllPaginatedResponseDTO>(
      Attendance_SchoolReadAllPaginated,
      data
    );


  }

UserAffiliationMapping_AttendanceCheckInCheckOut(
 data: AttendanceCheckInCheckOutRequestDTO
): Observable<AttendanceCheckInCheckOutResponseDTO> {

 return this.http.post<AttendanceCheckInCheckOutResponseDTO>(
   Attendance_CheckInCheckOut,
   data
 );

}

}